import Vue from "vue";
import Vuex from "vuex";
import axios from "@/axios.js";
import Auth from "@aws-amplify/auth";
import store from "../store/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: "",
      reconnectError: false,
    },
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      if (Auth.user) {
        axios.get(`/caravanist`).then((response) => {
          if (response.data) {
            store.commit("UPDATE_USER_INFO", response.data);
          }
          const { uuid } = response.data;
          Vue.prototype.$uuid = uuid;
          if (event && event?.currentTarget) {
            if (event?.currentTarget?.readyState === 1) {
              event?.currentTarget?.sendObj({
                uuid,
                action: "joinCaravanist",
              });
            }
          }
        });
      }
      Vue.prototype.$socket = event?.currentTarget;
      state.socket.isConnected = true;
    },
    SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message;
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
  },
  actions: {
    sendMessage: function (context, message) {
      Vue.prototype.$socket.send(message);
    },
  },
});
